(function () {
  if (!window.Shopify?.loadFeatures) return;

  Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error || !Shopify.customerPrivacy) return;

    var PAGE_LOCK = "_advertease_manage_lock";
    var adUrl = "https://advertease.store/manage.js";

    if (!window[PAGE_LOCK]) window[PAGE_LOCK] = false;

    tryLoadTags();
    document.addEventListener('visitorConsentCollected', function (ev) {
      if (ev?.detail?.marketingAllowed) tryLoadTags();
    }, { once: true });

    function tryLoadTags() {
      if (!marketingAllowed() || window[PAGE_LOCK]) return;
      window[PAGE_LOCK] = true;
      addScriptOnce("https://swrap.tradedoubler.com/wrap?id=32329", true);
      addScriptOnce(adUrl, false);
      addScriptOnce("https://wd-ret.io/rtg/v1/retag.js", true);
    }

    function marketingAllowed() {
      if (typeof Shopify.customerPrivacy.marketingAllowed === 'function') {
        return !!Shopify.customerPrivacy.marketingAllowed();
      }
      if (typeof Shopify.customerPrivacy.currentVisitorConsent === 'function') {
        var c = Shopify.customerPrivacy.currentVisitorConsent() || {};
        return c.marketing === 'yes' || c.marketing === true;
      }
      return false;
    }

    function addScriptOnce(src, asyncFlag) {
      if (hasScriptByPath(src)) return;
      var s = document.createElement('script');
      s.src = src;
      if (asyncFlag) s.async = true;
      (document.head || document.documentElement).appendChild(s);
    }

    function hasScriptByPath(src) {
      try {
        var u = new URL(src, document.baseURI);
        var path = u.origin + u.pathname;
        var scripts = document.getElementsByTagName('script');
        for (var i = 0; i < scripts.length; i++) {
          var s = scripts[i].getAttribute('src');
          if (!s) continue;
          var u2 = new URL(s, document.baseURI);
          if ((u2.origin + u2.pathname) === path) return true;
        }
      } catch (_) {}
      return false;
    }
  });
})();
